"use strict";
import axios from "../../../axios";
import deepSeal from "../../../lib/deep_seal";
class Params {
    constructor() {
        Object.assign(this, { "id": null });
        deepSeal(this);
    }
}
class BuildableParams {
    constructor() {
        Object.assign(this, { "id": null });
    }
    build(key) { return {}[key]; }
}
export default {
    Params: Params,
    BuildableParams: BuildableParams,
    execute: function (params) {
        return axios.get("/jtj/queries/aggregates__resume_question", { params });
    }
};
